import { Injectable } from '@angular/core';
import { Resource } from '@mode/shared/util-halogen';
import { ModeFormFactoryService } from './mode-form.factory';
import { ModeLinkFactoryService } from './mode-link.factory';

@Injectable({ providedIn: 'root' })
export class ModeResourceFactoryService {
  constructor(modeLinkFactory: ModeLinkFactoryService, modeFormFactory: ModeFormFactoryService) {
    // Patch Resource prototype
    Object.assign(Resource.prototype, {
      createLink(value): any {
        return modeLinkFactory.create(Resource, value);
      },

      createForm(value): any {
        return modeFormFactory.create(Resource, value);
      },
    });
  }

  create(properties: any, options = null) {
    return new Resource(properties, options);
  }
}

/**
 * Adapter to help migrate to Angular 2 dependency injector.
 * Migration Guide: If you're migrating a service that depends on this, update to ModeResourceFactoryService.create first.
 *
 * @deprecated Use ModeResourceFactoryService instead
 */
export const ModeResourceFactoryMigrationAdapter: Function = function (
  modeResourceFactory: ModeResourceFactoryService
) {
  return function (properties: any, options = null) {
    return modeResourceFactory.create(properties, options);
  };
};
ModeResourceFactoryMigrationAdapter.$inject = ['ModeResourceFactory'];
